import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

const SubHeader = ({
    header,
}) => (
    <Typography gutterBottom variant="h6" component="h3">
        {header}
    </Typography>
);

SubHeader.propTypes = {
    header: PropTypes.string.isRequired,
};

export default SubHeader;
